import {useEffect, useState} from "react";


export const HORIZONTAL_DISPLAY_TYPE = 'horizontal';
export const VERTICAL_DISPLAY_TYPE = 'vertical';

export function useOptionDisplayType({
    anchorRef,
    optionListRef,
}) {
    const [displayType, setDisplayType] = useState(null);

    useEffect(() => {
        const anchor = anchorRef.current;
        const optionList = optionListRef.current;

        if (anchor === null || optionList === null) {
            setDisplayType(VERTICAL_DISPLAY_TYPE);
            return;
        }

        setDisplayType(getDisplayType(anchor, optionList));
    }, [anchorRef, optionListRef]);

    const getDisplayType = (anchor, optionList) => {
        const accumulationWidth = Array.from(optionList.children).reduce((accumulator, option) => {
            return accumulator + option.offsetWidth;
        }, 0);

        if (anchor.offsetWidth >= accumulationWidth) {
            return HORIZONTAL_DISPLAY_TYPE;
        }

        return VERTICAL_DISPLAY_TYPE;
    };

    return displayType;
}
